import Option from '@/modules/common/models/option/option.ts';
import type { TableId } from '@/modules/common/enums/table-id.enum.ts';

export class ContractorOption extends Option {
  readonly id: number;
  readonly tableId: TableId;

  constructor(response: any) {
    super(response, 'CustomKey', 'Исполнитель');

    this.id = response['RESPONSIBLE_ID'];
    this.tableId = response['RESPONSIBLE_TABLE_ID'];
  }

  protected getCode(response: any) {
    return `${response['RESPONSIBLE_ID']}_${response['RESPONSIBLE_TABLE_ID']}`;
  }
}
